import { NgModule } from '@angular/core';
import { TranslationPipe } from './translation-pipe';
import { ConnectionPipe } from './connection-pipe ';
import { SortListPipe } from './sort-pipe';

@NgModule({
  imports: [],
  declarations: [
    TranslationPipe,
    ConnectionPipe,
    SortListPipe
  ],
  exports: [
    TranslationPipe,
    ConnectionPipe,
    SortListPipe
  ]
})
export class SharedPipeModule { }
